export const HeaderContents = {
  buttons: {
    login: "Log In",
    logout: "Log Out",
    howItWorks: "How it works?"
  }
};
